import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';

import { I18n } from 'components/translate';
import { formatBytes } from 'helpers/File';
import { MAX_QUIZ_PROFILE_IMG_SIZE } from 'modules/file/constants';

import ImageUploader from './ImageUploader';

class ProfileImageUpload extends PureComponent {
  render() {
    return (
      <div className="profile-image-upload-wrapper">
        <p className="profile-image-upload-title">
          <I18n label="files.image.insert_image" />
        </p>
        <div className="profile-image-upload-content">
          <div className="profile-image-upload">
            <ImageUploader {...this.props} />
          </div>
          <div className="profile-image-upload-description">
            <p>
              <I18n label="quiz_editor.profiles.insert_image_tip_1" />
            </p>
            <p>
              <I18n label="quiz_editor.profiles.insert_image_tip_2" />
            </p>
            <p>
              <I18n
                html
                label="quiz_editor.profiles.insert_image_tip_3"
                data={{ size: formatBytes(MAX_QUIZ_PROFILE_IMG_SIZE) }}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ProfileImageUpload);
